import { SelectGroupListItem } from "../../../components/Select/SelectGroupListItem.js";
import { SelectGroupValueSingle } from "../../../components/Select/SelectGroupValueSingle.js";
import { SelectGroupValueMulti } from "../../../components/Select/SelectGroupValueMulti.js";
import { useAllowedUserStatusOptionsAndPositions } from "../hooks/useAllowedUserStatusOptionsAndPositions.js";
import { useMemo } from "react";
import { Select } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Users/shared/SelectAllowedUserPositionOption.tsx
var SelectedSingle = ({ color, title }) => /* @__PURE__ */ jsx(SelectGroupValueSingle, {
	color,
	label: title
});
var SelectedMulti = ({ color, title }, onRemove) => /* @__PURE__ */ jsx(SelectGroupValueMulti, {
	color,
	label: title,
	onRemove
});
var ListItem = ({ color, title }) => /* @__PURE__ */ jsx(SelectGroupListItem, {
	color,
	label: title
});
var SelectAllowedUserPositionOption = ({ targetUserId, value, ...atalayaSelectProps }) => {
	const { data, loading } = useAllowedUserStatusOptionsAndPositions(targetUserId);
	const options = useMemo(() => data?.userPositionOptions || [], [data?.userPositionOptions]);
	return /* @__PURE__ */ jsx(Select, {
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		isLoading: loading,
		optionLabelExtractor: ({ title }) => title,
		optionValueExtractor: ({ id }) => id,
		options,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectAllowedUserPositionOption };

//# sourceMappingURL=SelectAllowedUserPositionOption.js.map